module.exports = __webpack_public_path__ + "static/analyse-cafd7f3ce344e3658ee3eee752b3ac83.png";